<template>
    <div>
        <div class="text-h6 font-weight-bold my-2 text-darkblue">Prévisualisation des contacts de la liste</div>
        <div class="mb-3" v-if="contacts.length > 0">Nombre de contacts trouvés : <b>{{ contacts.length }}</b></div>
        <div class="mb-3" v-else>Aucun contact trouvé pour ces filtres</div>

        <v-data-table-virtual :items="contacts" :headers="headers" :height="600" item-value="id_inscription"
            fixed-header density="compact" bordered>
            <template #[`item.nom_prenom`]="{ item }">
                {{ item.nom }} {{ item.prenom }}
            </template>
            <template #[`item.mail`]="{ item }">
                {{ item.mail }}
            </template>
            <template #[`item.course`]="{ item }">
                {{ getCourseName(item.id_course) }}
            </template>
            <template #[`item.option`]="{ item }">
                {{ getOptions(item.id_option, item.quantite) }}
            </template>
        </v-data-table-virtual>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {

    props: ['contacts'],
    data() {
        return {
            headers: [
                { title: 'Nom - Prénom', key: 'nom_prenom' },
                { title: 'Email', key: 'mail' },
                { title: 'Course', key: 'course' },
                { title: 'Options', key: 'option' },
            ],
        }
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        getCourseName(id_course) {
            if (id_course == '' || id_course == null || id_course == "0") return 'Non sportif';
            return this.mainStore.module.courses.list.find(course => course.id == id_course).nom;
        },
        getOptions(id_options, quantites) {
            if (id_options == '' || id_options == null) return '';
            let split_id_options = id_options.split(',');
            let split_quantites = quantites.split(',');
            let options = [];
            for (let i = 0; i < split_id_options.length; i++) {
                options.push(split_quantites[i] + 'x ' + this.mainStore.module.options.list.find(option => option.id == split_id_options[i]).nom);
            }
            return options.join(', ');

        },

    }
}
</script>

<style lang="scss" scoped></style>